export default "__VITE_ASSET__CHpeltVE__"